import { api } from './client';
import type { PrinterConfig, PrinterConfigRequest } from '../types';

export const printersApi = {
  list: (storeId: number) =>
    api
      .get<PrinterConfig[]>('/printer-configs', { params: { storeId } })
      .then((r) => r.data),

  create: (body: PrinterConfigRequest) =>
    api.post<PrinterConfig>('/printer-configs', body).then((r) => r.data),

  update: (id: number, body: Partial<PrinterConfigRequest>) =>
    api.put<PrinterConfig>(`/printer-configs/${id}`, body).then((r) => r.data),
};
